import * as React from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Tooltip from '@mui/material/Tooltip';

interface IInlineStyles {
    [key: string]: unknown
}

type CopyToClipboardProps = {
  content: string;
  clipboardInlineStyles?: IInlineStyles;
};

const DEFAULT_COPY_TO_CLIPBOARD_INLINE_STYLES: IInlineStyles = {
    cursor: 'pointer',
    mr: 1
};

export const CopyToClipboard = ({
    content,
    clipboardInlineStyles = DEFAULT_COPY_TO_CLIPBOARD_INLINE_STYLES
}: CopyToClipboardProps) => {
    const [shouldShowTooltip, setShouldShowTooltip] = React.useState(false);

    const onCopy = (textToCopy: string, event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        navigator.clipboard.writeText(textToCopy);
        setShouldShowTooltip(true);
        setTimeout(() => {
            setShouldShowTooltip(false);
        }, 1000);
    };

    const onTooltipClose = () => {
        setShouldShowTooltip(false);
    };

    return (
        <ClickAwayListener onClickAway={onTooltipClose}>
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                onClose={onTooltipClose}
                open={shouldShowTooltip}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={'Copied to clipboard!'}
            >
                <ContentCopyIcon
                    fontSize="small"
                    sx={clipboardInlineStyles}
                    onClick={(event) => {
                        onCopy(content, event);
                    }}
                />
            </Tooltip>
        </ClickAwayListener>
    );
};
